/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'share-modal.accordion-button-label':
    'Who gets weekly {entity, select, project {project} goal {goal} other {}} updates?',
  'share-modal.add-as-follower-checkbox-label': 'Add as follower',
  'share-modal.add-as-follower-checkbox-tooltip':
    'Followers get a weekly update on {entity, select, project {project} goal {goal} other {}} in their digest',
  'share-modal.all-tab-label': 'All',
  'share-modal.contributors-tab-label': 'Contributors',
  'share-modal.followers-tab-label': 'Followers',
  'share-modal.followers-title': 'Followers',
  'share-modal.footer.access-level-disclaimer':
    'Everyone with workspace access can see this {entity, select, project {project} goal {goal} other {}}.',
  'share-modal.footer.access-level-private-disclaimer':
    '{entity, select, project {Private project} goal {Private goal} other {}}',
  'share-modal.footer.copy-link-button': 'Copy Link',
  'share-modal.footer.copy-link-button.copied-tooltip': 'Copied!',
  'share-modal.footer.copy-link-button.tooltip':
    'Copy link to {entity, select, project {project} goal {goal} other {}}',
  'share-modal.modal.user-picker.add-more-placeholder': 'Add more people',
  'share-modal.share-button': 'Share',
  'share-modal.share-title': 'Share',
  'share-modal.user-item.can-edit-label': 'Can edit',
  'share-modal.user-picker.placeholder': 'Search and invite people',
  'shareModal.followers-empty-state.default-title': 'Missing key stakeholders?',
  'shareModal.followers-empty-state.goal-cta':
    'Make sure they get the latest update on your goal in their monthly digest by adding them as a follower or connecting a Slack or MS Teams channel',
  'shareModal.followers-empty-state.project-cta':
    'Add key teams and stakeholders as followers to keep them in the loop. Connect a channel to share updates directly in chat.',
  'shareModal.followers-empty-state.project-title': 'Reach a wider audience by adding followers',
};
